//import 'styles/colors.css';
import { DetermineIfChristmasTime, DetermineIfEasterTime } from './special_times_of_year';

export { ABI } from './abi';
export { _CONTRACT_DATA as CONTRACTS } from './contracts.js';
export { _CHAIN_DATA as CHAIN_DETAILS } from './chains.js';
export { _FIAT_PRICE_API as FIAT_PRICE_API } from './currencies.js';
export { _FIAT_API_NAME_CONVERSIONS as FIAT_API_NAME_CONVERSIONS } from './currencies.js';
export { _SUPPORTED_FIAT_CURRENCIES as FIAT_CURRENCIES } from './currencies.js';
export { _GLOBAL_NAMESPACE as GLOBAL_NAMESPACE } from './window.js';

export const LOCAL_STORAGE_PREFIX = 'dogebets_';
export const DOMAIN_NAME = 'dogebets.gg';
//export const DOMAIN_NAME = 'localhost'; // debug
export const EMBEDDED_SESSION = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();

export const IS_CHRISTMAS_TIME = DetermineIfChristmasTime();
export const IS_EASTER_TIME = DetermineIfEasterTime();

export const USE_MAINNET = Boolean(Number(process.env.REACT_APP_IS_ON_MAINNET));

export const MIN_BETS = { // ether
  'bsc': 0.001,
  'polygon': 0.01,
  'dogechain': 0.01,
}
export const GAS_INCREMENTS = { // Gwei
  'bsc': 1,
  'polygon': 5,
  'dogechain': 10,
}
export const LOW_PRIZE_POOL_THRESHOLD = { // Ether
  'bsc': 0.5,
  'polygon': 10,
  'dogechain': 100,
}
export const PRICE_API_ALT_ENDPOINT = 'https://bapi2.dogebets.gg/price/'
export const PRICE_API_DEFAULT_ENDPOINT = 'https://api.binance.com/api/v3/ticker/price?symbol='
export const TELEGRAM_GROUP_LINK = 'https://t.me/dogebets';
export const TWITTER_LINK = 'https://twitter.com/DogeBets_Main';
export const GITHUB_LINK = '#';
export const DISCORD_LINK = 'https://discord.gg/SYpWZVZwFD';
export const availablePositions = Object.freeze({ bull: 0, bear: 1 });
export const BET_SIZE_PRECISION_DECIMALS = 4;
export const REWARD_PRECISION_DECIMALS = {
  'bsc': 4,
  'polygon': 0,
  'dogechain': 0,
}

export const FORCED_PRICE_VERIFICATION_DELAY = 1000;
export const HISTORY_ENTRIES_PER_PAGE = 10;
export const MAX_ROUNDS_CLAIMALL_DEFAULT = 100;
export const MAX_ROUNDS_CLAIMALL_HARDCAP = 5000; // approximately one full day(24 hours) worth of rounds
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export const BSC_MIN_GAS_HARDCAP = '1000000000'; // eliminates bugs with BSC reporting wrong gas price


// This block used to retrieve CSS variables from colors.css, imported above
/*
const rootStyles = getComputedStyle(document.querySelector('html'));
export const BULL_GREEN_COLOR = rootStyles.getPropertyValue('--color-bull-green');
export const BEAR_RED_COLOR = rootStyles.getPropertyValue('--color-bear-red');
export const THEME_WHITE_COLOR = rootStyles.getPropertyValue('--color-theme-white');
export const MENU_PURPLE_COLOR = rootStyles.getPropertyValue('--color-menu-purple');
*/
